"use strict";
angular.module("headerLoginModule", [])
	.controller("headerLoginCtrl", ["$scope", "httpService", function($scope, httpService) {
		initStatus();
		initData();
		function initStatus() {
			$scope.info = {};
			$scope.data = {};
		}
		function initData(){
			getseconddomain();
		}
		/**
		 * [getseconddomain description]获得admin 登录配置信息
		 * 
		 * @return {[type]} [description]
		 */
		function getseconddomain() {
			var params = {
				domainPrefix: '123'
			}
			httpService.http("/mcnww/web/tenant/getSecondDomain.do", params, "get").then(function(data) {
				if(data.data.platformlogo==null){
					$scope.data.platformlogo ='images/logo.png';
				}else{
					$scope.data.platformlogo = JSON.parse(data.data.platformlogo)[0];
				}
				if(data.data.platformName==null) {
					$scope.data.platformName = '通讯员平台';
				} else {
					$scope.data.platformName = data.data.platformName;
				}
			});
		}
	}]);